import { Injectable } from '@angular/core';
import { ToastButton, ToastController, ToastOptions } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import { close } from 'ionicons/icons';
import { UnauToastConfig } from './toast.model';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private readonly baseToastOptions: ToastOptions = {
    duration: 2000,
    cssClass: ['unau-toast'],
    buttons: [
      {
        icon: 'close',
        role: 'cancel',
      },
    ],
  };

  constructor(private toastController: ToastController) {
    addIcons({ close });
  }

  private async toast(options: ToastOptions): Promise<HTMLIonToastElement> {
    // combine default config vs custom config
    const buttons = [
      ...((options.buttons as ToastButton[]) ?? []),
      ...(this.baseToastOptions.buttons as ToastButton[]),
    ];

    const toastInstance = await this.toastController.create({
      ...this.baseToastOptions,
      ...options,
      buttons,
    });
    await toastInstance.present();
    return toastInstance;
  }

  public async infoToast(config: UnauToastConfig): Promise<HTMLIonToastElement> {
    return await this.toast({
      color: 'unauInfo',
      icon: 'assets/icon/icon-toast-info.svg',
      header: config.header,
      message: config.message,
      buttons: config.buttons,
      duration: config.duration ?? this.baseToastOptions.duration,
    });
  }

  public async successToast(config: UnauToastConfig): Promise<HTMLIonToastElement> {
    return await this.toast({
      color: 'unauSuccess',
      icon: 'assets/icon/icon-toast-success.svg',
      header: config.header,
      message: config.message,
      buttons: config.buttons,
      duration: config.duration ?? this.baseToastOptions.duration,
    });
  }

  public async errorToast(config: UnauToastConfig): Promise<HTMLIonToastElement> {
    return await this.toast({
      color: 'unauError',
      icon: 'assets/icon/icon-toast-error.svg',
      header: config.header,
      message: config.message,
      buttons: config.buttons,
      duration: config.duration ?? this.baseToastOptions.duration,
    });
  }

  public async warningToast(config: UnauToastConfig): Promise<HTMLIonToastElement> {
    return await this.toast({
      color: 'unauWarning',
      icon: 'assets/icon/icon-toast-warning.svg',
      header: config.header,
      message: config.message,
      buttons: config.buttons,
      duration: config.duration ?? this.baseToastOptions.duration,
    });
  }
}
